export default {
  data () {
    return {
      individualOptions: [
        { label: 'Individual', value: true },
        { label: 'Business / Generic', value: false }
      ]
    }
  }
}
